// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3cifw","col":"styles_col__4A0xp"};